import { toFlatField } from '../oasis-types';
export const RespiratoryVersioned = {
    smokingHistory: { e1: { alias: 'smokingHistory', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
    breathingPattern: { e1: { alias: 'breathingPattern', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
    lungAuscultation: { e1: { alias: 'lungAuscultation', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
    cough: { e1: { alias: 'cough', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
    cpapBipap: { e1: { alias: 'cpapBipap', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
    mechanicalVentilator: { e1: { alias: 'mechanicalVentilator', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
    tracheostomy: { e1: { alias: 'tracheostomy', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
    treatments: { e1: { alias: 'treatments', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
};
export const Respiratory = toFlatField(RespiratoryVersioned);
